
import React, { useEffect, useState } from "react";
import {
  FiHome,
  FiInfo,
  FiUsers,
  FiTool,
  FiBriefcase,
  FiMail,
  FiArrowUpRight,
  FiMenu,
  FiX,
} from "react-icons/fi";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



  const navItems = [
    { name: "Home", href: "#home", icon: FiHome },
    { name: "About", href: "#About", icon: FiInfo },
    { name: "Team", href: "#Team", icon: FiUsers },
    { name: "What We Do", href: "#whatwedo", icon: FiTool },
    { name: "Services", href: "#Services", icon: FiBriefcase },
    { name: "Contact", href: "#Contact", icon: FiMail },
  ];

  const closeMobileMenu = () => {
    setMobileOpen(false);
  };

  return (
    <>
      <style>{`

        /* ==============================
           HEADER
        ============================== */

        .sg-header {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 9999;
          padding: 18px 0;
          transition:
            background 0.3s ease,
            box-shadow 0.3s ease,
            padding 0.3s ease;
        }

        .sg-header.scrolled {
          padding: 11px 0;
          background: rgba(255, 255, 255, 0.94);
          box-shadow: 0 8px 30px rgba(21, 55, 96, 0.08);
          backdrop-filter: blur(18px);
        }
          .sg-nav-icon {
  font-size: 15px;
  margin-right: 6px;
  flex-shrink: 0;
}

.sg-mobile-icon {
  font-size: 17px;
  margin-right: 11px;
  flex-shrink: 0;
}

.sg-header-cta-icon {
  width: 20px;
  height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 5px;
  background: rgba(255,255,255,0.16);

  font-size: 16px;
}

        .sg-header-container {
          width: min(1380px, 92%);
          margin: auto;

          display: flex;
          align-items: center;
          justify-content: space-between;

          min-height: 64px;
          padding: 0 8px;
        }

        /* ==============================
           LOGO
        ============================== */

        .sg-logo {
          display: flex;
          align-items: center;
          gap: 12px;

          text-decoration: none;
          color: #10213f;

          flex-shrink: 0;
        }

        .sg-logo-symbol {
          position: relative;

          width: 49px;
          height: 52px;

          display: flex;
          align-items: center;
          justify-content: center;

          color: #1558c0;

          border-left: 2px solid #1558c0;
          border-right: 2px solid #1558c0;

          clip-path: polygon(
            50% 0%,
            100% 22%,
            100% 100%,
            0% 100%,
            0% 22%
          );
        }

        .sg-logo-symbol::before {
          content: "";

          position: absolute;

          width: 20px;
          height: 36px;

          left: 13px;
          top: 8px;

          border-left: 3px solid #1558c0;
          border-right: 3px solid #1558c0;
        }

        .sg-logo-symbol::after {
          content: "";

          position: absolute;

          width: 32px;
          height: 3px;

          left: 7px;
          bottom: 9px;

          background: #f39818;
        }

        .sg-logo-text {
          display: flex;
          flex-direction: column;
          line-height: 1;
        }

        .sg-logo-name {
          color: #1558c0;

          font-size: 22px;
          font-weight: 900;

          letter-spacing: 0.3px;
        }

        .sg-logo-subtitle {
          margin-top: 6px;

          color: #26364e;

          font-size: 8.5px;
          font-weight: 700;

          letter-spacing: 1.55px;
        }

        /* ==============================
           NAVIGATION
        ============================== */

        .sg-navigation {
          display: flex;
          align-items: center;
          gap: 7px;

          margin-left: auto;
          margin-right: 28px;
        }

        .sg-nav-link {
          position: relative;

          display: flex;
          align-items: center;

          height: 45px;
          padding: 0 13px;

          color: #26364e;

          text-decoration: none;

          font-size: 14px;
          font-weight: 600;

          transition: color 0.25s ease;
        }

        .sg-nav-link::after {
          content: "";

          position: absolute;

          left: 13px;
          right: 13px;
          bottom: 4px;

          height: 2px;

          border-radius: 10px;

          background: #1558c0;

          transform: scaleX(0);
          transform-origin: center;

          transition: transform 0.25s ease;
        }

        .sg-nav-link:hover {
          color: #1558c0;
        }

        .sg-nav-link:hover::after {
          transform: scaleX(1);
        }

        .sg-nav-link.active {
          color: #1558c0;
        }

        .sg-nav-link.active::after {
          transform: scaleX(1);
        }

        /* ==============================
           HEADER CTA
        ============================== */

        .sg-header-cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;

          min-height: 48px;

          padding: 0 21px;

          color: #ffffff;

          text-decoration: none;

          border-radius: 8px;

          background: linear-gradient(
            135deg,
            #1558c0,
            #2874dd
          );

          box-shadow:
            0 10px 25px rgba(21, 88, 192, 0.20);

          font-size: 12px;
          font-weight: 800;

          letter-spacing: 0.5px;

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease;
        }

        .sg-header-cta:hover {
          transform: translateY(-2px);

          box-shadow:
            0 14px 30px rgba(21, 88, 192, 0.30);
        }

        .sg-header-cta-icon {
          width: 20px;
          height: 20px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 5px;

          background: rgba(255,255,255,0.16);

          font-size: 11px;
        }

        /* ==============================
           MOBILE BUTTON
        ============================== */

        .sg-mobile-toggle {
          display: none;

          width: 44px;
          height: 44px;

          border: 1px solid #dce5f0;
          border-radius: 9px;

          background: #ffffff;

          cursor: pointer;

          flex-direction: column;
          align-items: center;
          justify-content: center;

          gap: 5px;
        }

        .sg-mobile-toggle span {
          width: 20px;
          height: 2px;

          border-radius: 10px;

          background: #1558c0;

          transition:
            transform 0.3s ease,
            opacity 0.3s ease;
        }

        .sg-mobile-toggle.open span:nth-child(1) {
          transform: translateY(7px) rotate(45deg);
        }

        .sg-mobile-toggle.open span:nth-child(2) {
          opacity: 0;
        }

        .sg-mobile-toggle.open span:nth-child(3) {
          transform: translateY(-7px) rotate(-45deg);
        }

        /* ==============================
           MOBILE MENU
        ============================== */

        .sg-mobile-menu {
          display: none;

          position: absolute;

          top: calc(100% + 4px);
          left: 4%;

          width: 92%;

          padding: 12px;

          border: 1px solid #e0e8f2;
          border-radius: 15px;

          background: rgba(255,255,255,0.98);

          box-shadow:
            0 20px 50px rgba(25,55,90,0.14);

          backdrop-filter: blur(20px);

          animation: sgMobileMenu 0.25s ease;
        }

        .sg-mobile-menu.open {
          display: block;
        }

        .sg-mobile-link {
          display: flex;
          align-items: center;

          min-height: 48px;

          padding: 0 15px;

          color: #26364e;

          border-radius: 8px;

          text-decoration: none;

          font-size: 14px;
          font-weight: 600;

          transition:
            background 0.2s ease,
            color 0.2s ease;
        }

        .sg-mobile-link:hover {
          color: #1558c0;
          background: #f1f6fd;
        }

        .sg-mobile-cta {
          width: 100%;

          margin-top: 8px;
        }

        @keyframes sgMobileMenu {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* ==============================
           RESPONSIVE
        ============================== */

        @media (max-width: 1100px) {

          .sg-navigation {
            gap: 0;
            margin-right: 12px;
          }

          .sg-nav-link {
            padding: 0 8px;
            font-size: 13px;
          }

          .sg-header-cta {
            padding: 0 14px;
            font-size: 11px;
          }

          .sg-logo-name {
            font-size: 19px;
          }

          .sg-logo-subtitle {
            font-size: 7px;
          }
        }

        @media (max-width: 850px) {

          .sg-navigation {
            display: none;
          }

          .sg-header-cta {
            display: none;
          }

          .sg-mobile-toggle {
            display: flex;
          }

          .sg-mobile-menu {
            display: none;
          }

          .sg-mobile-menu.open {
            display: block;
          }

          .sg-header {
            padding: 12px 0;
          }

          .sg-header.scrolled {
            padding: 9px 0;
          }
        }

        @media (max-width: 500px) {

          .sg-header-container {
            width: 94%;
            min-height: 55px;
          }

          .sg-logo {
            gap: 8px;
          }

          .sg-logo-symbol {
            width: 38px;
            height: 43px;
          }

          .sg-logo-symbol::before {
            width: 16px;
            height: 29px;
            left: 10px;
            top: 7px;
          }

          .sg-logo-symbol::after {
            width: 26px;
            left: 5px;
            bottom: 7px;
          }

          .sg-logo-name {
            font-size: 16px;
          }

          .sg-logo-subtitle {
            margin-top: 5px;
            font-size: 6px;
            letter-spacing: 1px;
          }

          .sg-mobile-toggle {
            width: 40px;
            height: 40px;
          }
        }

      `}</style>

      <header className={`sg-header ${scrolled ? "scrolled" : ""}`}>

        <div className="sg-header-container">

          {/* LOGO */}
          <a
            href="#home"
            className="sg-logo"
            onClick={closeMobileMenu}
          >

            <div className="sg-logo-symbol">
              <span></span>
            </div>

            <div className="sg-logo-text">
              <div className="sg-logo-name">
                STRUCTGUARD
              </div>

              <div className="sg-logo-subtitle">
                CONSTRUCTION SERVICES LLP
              </div>
            </div>

          </a>


          {/* DESKTOP NAVIGATION */}
          <nav className="sg-navigation">
            {navItems.map((item, index) => {
              const Icon = item.icon;

              return (
                <a
                  key={item.name}
                  href={item.href}
                  className={`sg-nav-link ${index === 0 ? "active" : ""
                    }`}
                >
                  <Icon className="sg-nav-icon" />
                  {item.name}
                </a>
              );
            })}
          </nav>


          {/* DESKTOP CTA */}
          <a
            href="#contact"
            className="sg-header-cta"
          >
            <span className="sg-header-cta-icon">
              <FiArrowUpRight />
            </span>

            REQUEST AN ESTIMATE
          </a>

          {/* MOBILE MENU BUTTON */}
          <button
            className="sg-mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation"
            aria-expanded={mobileOpen}
          >
            {mobileOpen ? <FiX size={23} /> : <FiMenu size={23} />}
          </button>

        </div>


        {/* MOBILE NAVIGATION */}
        <div
          className={`sg-mobile-menu ${mobileOpen ? "open" : ""
            }`}
        >

          {navItems.map((item) => {
            const Icon = item.icon;

            return (
              <a
                key={item.name}
                href={item.href}
                className="sg-mobile-link"
                onClick={closeMobileMenu}
              >
                <Icon className="sg-mobile-icon" />
                {item.name}
              </a>
            );
          })}

          <a
            href="#contact"
            className="sg-header-cta sg-mobile-cta"
            onClick={closeMobileMenu}
          >
            <span className="sg-header-cta-icon">
              <FiArrowUpRight />
            </span>

            REQUEST AN ESTIMATE
          </a>

        </div>

      </header>
    </>
  );
};

export default Header;

